export default {
	define: {
		"timeout": 30000,
		"env": "prod",
  	"BASE_URL": "https://yue.reactmobile.cn",
	}
}